import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'

const FooterMenu = ({ placeholders: { menuItems }, ...props }) =>
  <Nav>
    { menuItems }
  </Nav>

FooterMenu.propTypes = {
  placeholders: PropTypes.shape({
    menuItems: PropTypes.array
  })
}

FooterMenu.type = 'FooterMenu'
FooterMenu.placeholders = ['menuItems']

export default FooterMenu

const Nav = styled.div`
  ${Media.desktop`
    display: table-cell;
    width: 33%;
    margin: 0 auto;
  `}
`
